import React from 'react';
import AppRoute from './Routes';

function App() {
    return <AppRoute />;
}

export default App;
